import React from 'react'
import CustomerHubDetailPage from "./CustomerHubDetailPage"
import {onAddTab, onChangeActiveTab, onChangeMainTab} from "../../../store/action"
import {connect} from "react-redux"

function CustomerHubDetailContainer(props) {
    const {match, idCustomer, onChangeMainTab, onChangeActiveTab, onAddTab} = props
    const custId = match ? match.params.id : idCustomer

    return (
        <div className="CaseDetailContainer">
            <CustomerHubDetailPage
                custId={custId}
                onChangeMainTab={onChangeMainTab}
                onChangeActiveTab={onChangeActiveTab}
                onAddTab={onAddTab}
            />
        </div>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeMainTab: (data) => dispatch(onChangeMainTab(data)),
        onChangeActiveTab: (data) => dispatch(onChangeActiveTab(data)),
        onAddTab: (data) => dispatch(onAddTab(data)),
    }
}

export default connect(null, mapDispatchToProps)(CustomerHubDetailContainer)
